import React from "react";

const TimeTag = ()=>{
    return(
                    <div className="mathc-card-body-versus">
                    <div className="vs-line left-s"></div>                    
                    <img className="versus-img-match-card" src='https://assets.talachaapp.com/vs-removebg-preview.png' />
                    <div className="vs-line right-s"></div>
                    </div>
    )

}

export default TimeTag
